import OapQuiz from './code/Scripts/components/oap-quiz.vue';

export default {
  components: {
    OapQuiz,
  },
};
